import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import Button from 'modules/_shared/components/Buttons';
import { useEquityMarket } from '../contexts/EquityMarketContext';

const EquityMarketWelcomeBanner: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useEquityMarket();

  return (
    <div
      className="alert alert-icon alert-primary d-flex align-items-center justify-content-between px-4"
      role="alert"
    >
      <div className="d-flex align-items-center g-2">
        <em className="icon ni ni-exchange fs-24px text-primary bg-white rounded-circle p-2" />
        <strong>
          {t('WelcomeToSecondaryMarket', {
            society: data.societyName,
          })}
        </strong>{' '}
        {t('WelcomeToSecondaryMarketDescription')}
      </div>

      <Button text={t('HowItWorks')} onClick={actions.handleOpenHowItWorks} />
    </div>
  );
};

export default EquityMarketWelcomeBanner;
